import moment from 'moment';

const getBlockedTimeBasedOnAvailability = opening => {
    const startTime = moment(opening.StartTime, 'HH:mm:ss', true);
    const endTime = moment(opening.EndTime, 'HH:mm:ss', true);
    if (startTime.format('HH:mm') === '00:00' && endTime.format('HH:mm') === '00:00') return [];

    const startNum = startTime.hours() || 0;
    let endNum = endTime.hours() || 0;
    endNum = endNum === 0 ? 24 : endNum;

    const startMin = startTime.minutes();
    const endMin = endTime.minutes();

    let blockedHoursArr = [];
    if (startNum < endNum) {
        const hours = [...Array(25).keys()];
        blockedHoursArr = hours
            .filter(h => !(h > startNum && h < endNum))
            .reduce((acc, val, i, arr) => {
                if (val - arr[i - 1] === 1) {
                    acc[acc.length - 1].push(val);
                } else {
                    acc.push([val]);
                }
                return acc;
            }, []);
    } else {
        const before = [...Array(startNum + 1).keys()];
        const after = [...Array(endNum + 1).keys()];
        blockedHoursArr = [before, after];
    }

    return blockedHoursArr.map((group, i) => ({
        start: { h: group[0], m: i === 0 ? 0 : endMin, s: 0 },
        end: { h: group[group.length - 1], m: i === 1 ? 0 : startMin, s: 0 }
    }));
};

export const getRestDayEvents = availables => {
    const restDays = [];
    if (availables?.length > 0) {
        availables = [2, 3, 4, 5, 6, 7, 1].map(key => {
            const item = availables?.find(({ Day }) => Day === key);
            if (!item) {
                return {
                    Day: key,
                    IsRestDay: true,
                    StartTime: '00:00:00',
                    EndTime: '00:00:00'
                };
            }
            return item;
        });

        availables.forEach(opening => {
            if (!opening.IsRestDay) {
                const blocks = getBlockedTimeBasedOnAvailability(opening);
                blocks.forEach(block => {
                    if (block) {
                        const start = moment()
                            .set(block.start)
                            .format('HH:mm:ss');
                        const end =
                            block.end.h === 24
                                ? '23:59'
                                : moment()
                                      .set(block.end)
                                      .format('HH:mm:ss');

                        restDays.push({
                            title: 'Blocked',
                            allDay: false,
                            classNames: 'tw-block',
                            textColor: '#ffffff',
                            daysOfWeek: [opening.Day - 1],
                            startTime: start,
                            endTime: end,
                            extendedProps: {
                                type: 'rest'
                            }
                        });
                    }
                });
            }
        });
    }

    availables.forEach(day => {
        if (day.IsRestDay) {
            restDays.push({
                title: 'Blocked',
                allDay: true,
                daysOfWeek: [day.Day - 1],
                classNames: 'tw-block',
                textColor: '#ffffff',
                extendedProps: {
                    type: 'rest'
                }
            });
        }
    });

    return restDays;
};
